<template>
    <div class="tags">
        <TagClearable v-for="(tag, id) in tags" :key="`tag-${id}`" :tag="{label:tag, id}"/>
    </div>
</template>

<script>
import TagClearable from '@/components/forms/inputs/TagClearable.vue'
export default {
    name: "CheckBoxInput",
    components: { TagClearable },
    props: {
        tags: Object
    },
    methods: {
      clearTag (tag) {
        console.log('clearTag', tag)
      },
    }
}
</script>

<style scoped>
.tags {
    display: block;
    margin: -8px;
    flex-wrap: wrap;
}
</style>
